import { CmsArticleSearchPage } from './cms-article-search-page.interface';

export interface CmsArticleSearchResult {
  limit: number;
  offset: number;
  results: CmsArticleSearchPage[];
  total: number;
}
